// extracted by mini-css-extract-plugin
module.exports = {"settingContent":"settingContent--sZEiPXVb","setting":"setting--Z33WthLf","settingsTab":"settingsTab--Ix7GWKW9"};